import Form from "./components/Form.js";

function App() {
  return <Form />;
}

export default App;
